import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { authUserDataSelector } from '@cbridge-packages/auth';
import { avatarSize } from './AccountPreview.constant';
import { IAccountPreviewProps } from './AccountPreview.interface';

/** Header button with the user's avatar and name; opens the account popover. */
export const AccountPreview: FunctionComponent<IAccountPreviewProps> = (props) => {
  const { open, handleClick, sx } = props;

  const user = useSelector(authUserDataSelector);

  if (!user) {
    return null;
  }

  const initials = user.name
    .split(' ')
    .reduce((acc, item) => acc.concat(item.charAt(0).toUpperCase()), '');

  const avatarContent = (
    <Avatar
      alt={user.name || user.email || ''}
      sx={{ height: avatarSize, width: avatarSize }}
    >
      <Typography variant={'overline'}>
        {initials}
      </Typography>
    </Avatar>
  );

  return (
    <Tooltip title={user.name ?? 'Account'}>
      <Stack sx={{ py: 0, ...sx }}>
        <Button
          variant={'text'}
          startIcon={avatarContent}
          onClick={handleClick}
          aria-label={'Current User'}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup={'true'}
          aria-expanded={open ? 'true' : undefined}
        >
          {user.name}
        </Button>
      </Stack>
    </Tooltip>
  );
};
